import { render, staticRenderFns } from "./clipAttachmentPrimary.vue?vue&type=template&id=5375f9ca&"
import script from "./clipAttachmentPrimary.vue?vue&type=script&lang=js&"
export * from "./clipAttachmentPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports